import { render, staticRenderFns } from "./ClientAvailableTechs.vue?vue&type=template&id=65eddd04&scoped=true&"
import script from "./ClientAvailableTechs.vue?vue&type=script&lang=js&"
export * from "./ClientAvailableTechs.vue?vue&type=script&lang=js&"
import style0 from "./ClientAvailableTechs.vue?vue&type=style&index=0&id=65eddd04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eddd04",
  null
  
)

export default component.exports